"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.elevationTooltip = exports.elevationToast = exports.elevationNone = exports.elevationModal = exports.elevationMenu = exports.elevationCard = exports.elevationBackdrop = void 0;
const elevationNone = exports.elevationNone = '0';
const elevationCard = exports.elevationCard = '4';
const elevationTooltip = exports.elevationTooltip = '4';
const elevationMenu = exports.elevationMenu = '12';
const elevationBackdrop = exports.elevationBackdrop = '40';
const elevationModal = exports.elevationModal = '40';
const elevationToast = exports.elevationToast = '60';